import { smartCompare } from '~/clientUtils/sortingUtils';
import { CandidateLike } from '~/definitions/candidates';

const sortCandidates = <T extends CandidateLike>(a: T, b: T): number => {
    // 1) priority / ballotNumber (empty first, then numeric)
    const aVal = a.priority ?? a.ballotNumber;
    const bVal = b.priority ?? b.ballotNumber;
    const aEmpty = aVal == null || aVal === '';
    const bEmpty = bVal == null || bVal === '';

    if (aEmpty && !bEmpty) return -1;
    if (!aEmpty && bEmpty) return 1;
    if (!aEmpty && !bEmpty) {
        const numA = Number(aVal);
        const numB = Number(bVal);
        if (!Number.isNaN(numA) && !Number.isNaN(numB) && numA !== numB) {
            return numA - numB;
        }
    }

    // 2) last name
    const lastNameA = a.lastName ?? a.candidate_last_name ?? '';
    const lastNameB = b.lastName ?? b.candidate_last_name ?? '';
    const ln = smartCompare(lastNameA, lastNameB);
    if (ln !== 0) return ln;

    // 3) first name
    const firstNameA = a.firstName ?? a.candidate_first_name ?? '';
    const firstNameB = b.firstName ?? b.candidate_first_name ?? '';
    const fn = smartCompare(firstNameA, firstNameB);
    if (fn !== 0) return fn;

    // 4) id
    const idA = a.id ?? a.user_id ?? '';
    const idB = b.id ?? b.user_id ?? '';
    return smartCompare(idA, idB);
};

export default sortCandidates;
